import React, { useEffect, useRef, useState } from "react";
import Header from "../Common/Header";
import LeftMenu from "../Common/LeftMenu";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Footer from "../Common/Footer";
import { useSelector, useDispatch } from "react-redux";
import ContentFooter from "../Common/ContentFooter";
import Aos from "aos";
import "aos/dist/aos.css";
import Layout from "./Layout";
import BetSlip from "../../pages/BetSlip/BetSlip";
import BetSlipWidget from "../Common/BetSlipWidget";
import SlipBar from "../Common/SlipBar";
import SportRail from "../Common/SportRail";
import { getAllLeaguesBySport } from "../../helpers/repository";

import Bigwins from "../../pages/Bigwins/Bigwins";

function AppLayout(props) {
  const { t } = useTranslation();
  const [openBet, setOpenBet] = useState(false);

  const showSideBar = useSelector(
    (state) => state?.CommonState?.showSideBar ?? false,
  );
  // Set by a pushed screen's PageHeader (mobileHeader) so the mobile back-header
  // replaces the global header below md (RN single-header parity, no double chrome).
  const hideGlobalHeaderMobileFlag = useSelector(
    (state) => state?.CommonState?.hideGlobalHeaderMobile ?? false,
  );

  const history = useHistory();

  // Reactive router location — re-renders AppLayout on client-side navigation so
  // route-dependent chrome (like the wallet header hide below) stays correct.
  const routerLocation = useLocation();
  // Mobile web: hide the global app header below md when the screen owns its
  // header — the wallet flow (/payment) and any pushed screen using
  // PageHeader mobileHeader. Desktop (md+) always keeps the global header.
  const hideGlobalHeaderMobile =
    routerLocation.pathname === "/payment" ||
    routerLocation.pathname === "/refer-a-friend" ||
    hideGlobalHeaderMobileFlag;

  const pathname = routerLocation.pathname;

  // Desktop persistent left sport rail (design-kit SportRail) — same route set
  // SportsMenuBar used, restructured into rail groups. Real routes only; no
  // per-sport counts since the API doesn't return them yet.
  const showSportsRail =
    pathname.includes("/sports") ||
    pathname.includes("/league-details") ||
    pathname.includes("/sport") ||
    pathname.toLowerCase() === "/my-bets" ||
    pathname === "/bonuses-awarded" ||
    pathname === "/refer-a-friend";

  // BetSlip only shows on sports/league pages — not on wallet/deposits where
  // the wallet's own right column (OrderSummaryPanel) provides the right panel.
  const showBetSlip =
    pathname.includes("/sports") ||
    pathname.includes("/league-details") ||
    pathname.toLowerCase() === "/my-bets" ||
    pathname === "/bonuses-awarded" ||
    pathname === "/refer-a-friend";

  const RailSports = useSelector((state) => state?.Sports?.Index?.data ?? []);
  const getSportIcon = (name) => {
    const normalized = name?.toLowerCase();
    if (normalized === "soccer" || normalized === "football") {
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 shrink-0">
          <circle cx="12" cy="12" r="10"/>
          <path d="m12 2-2 7h4z"/>
          <path d="m10 9-6 4 3 6z"/>
          <path d="m14 9 6 4-3 6z"/>
          <path d="M12 22v-3l-3-6h6z"/>
        </svg>
      );
    }
    if (normalized === "basketball") {
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 shrink-0">
          <circle cx="12" cy="12" r="10"/>
          <path d="M6.2 6.2c2.4 2.4 2.4 6.4 0 8.8"/>
          <path d="M17.8 6.2c-2.4 2.4-2.4 6.4 0 8.8"/>
          <path d="M2 12h20"/>
          <path d="M12 2v20"/>
        </svg>
      );
    }
    if (normalized === "tennis") {
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 shrink-0">
          <circle cx="12" cy="12" r="10"/>
          <path d="M12 2a20 20 0 0 1 0 20"/>
          <path d="M2 12a20 20 0 0 1 20 0"/>
        </svg>
      );
    }
    if (normalized === "darts") {
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 shrink-0">
          <circle cx="12" cy="12" r="10"/>
          <circle cx="12" cy="12" r="6"/>
          <circle cx="12" cy="12" r="2"/>
          <path d="m22 2-6 6"/>
          <path d="M12 2v4"/>
          <path d="M12 18v4"/>
          <path d="M2 12h4"/>
          <path d="M18 12h4"/>
        </svg>
      );
    }
    if (normalized === "handball") {
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 shrink-0">
          <path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a1.2 1.2 0 0 1 0-1.7l.8-.8a1.2 1.2 0 0 1 1.7 0l2.5 2.5V3a1.5 1.5 0 0 1 3 0v4a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1 3 0v-2a1.5 1.5 0 0 1 3 0z"/>
        </svg>
      );
    }
    if (normalized === "american football" || normalized === "american_football") {
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 shrink-0">
          <path d="M16 8C12 4 4 12 8 16c4 4 12-4 8-8z"/>
          <path d="M8 16c-1.5 0-3-1.5-3-3m14-5c0 1.5-1.5 3-3 3"/>
          <path d="m9 15 6-6"/>
          <path d="m11 11 2 2"/>
        </svg>
      );
    }
    if (normalized === "boxing" || normalized === "mma") {
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 shrink-0">
          <path d="M12 22v-8h4v8M6 8V6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v2"/>
          <rect x="2" y="8" width="20" height="6" rx="2"/>
        </svg>
      );
    }
    if (normalized === "baseball") {
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 shrink-0">
          <circle cx="12" cy="12" r="10"/>
          <path d="M5 19A14 14 0 0 1 19 5"/>
          <path d="M19 19A14 14 0 0 0 5 5"/>
        </svg>
      );
    }
    if (normalized === "volleyball") {
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 shrink-0">
          <circle cx="12" cy="12" r="10"/>
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10"/>
          <path d="M12 2a15.3 15.3 0 0 0-4 10 15.3 15.3 0 0 0 4 10"/>
          <path d="M2 12h20"/>
        </svg>
      );
    }
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 shrink-0">
        <circle cx="12" cy="12" r="10"/>
        <path d="M12 2v20M2 12h20"/>
      </svg>
    );
  };

  // Real data only: sports come from the Sports store, leagues from the
  // leagues-by-sport API (cached in repository.js) for the sport in the URL
  // (soccer on the home page). The API sends no per-sport counts, so none are shown.
  const searchParams = new URLSearchParams(routerLocation.search);
  const railSportId = searchParams.get("sport_id") || searchParams.get("id") || "1";
  const [railLeagues, setRailLeagues] = useState([]);
  useEffect(() => {
    if (!showSportsRail) return;
    getAllLeaguesBySport(
      railSportId,
      (data) => setRailLeagues(Array.isArray(data) ? data : []),
      () => setRailLeagues([]),
    );
  }, [showSportsRail, railSportId]);

  const sportRailGroups = [
    {
      title: t("app_layout_top_sports", "Top Sports"),
      items: RailSports.map((sport) => ({
        id: `/sports-details?id=${sport.id}`,
        label: sport.name === "Soccer" ? "Football" : sport.name,
        icon: getSportIcon(sport.name),
      })),
    },
    {
      title:
        String(railSportId) === "1"
          ? t("app_layout_top_leagues", "Football Competitions")
          : t("app_layout_leagues", "Leagues"),
      items: railLeagues.slice(0, 8).map((league) => ({
        id: `/league-details?sport_id=${league.sport_id}&id=${league.bb_id}`,
        label: league.name,
      })),
    },
  ].filter((group) => group.items.length > 0);

  // The home page (/sports) lists football, so Football is the active rail item there.
  const activeSportRailId =
    routerLocation.pathname === "/sports"
      ? "/sports-details?id=1"
      : `${routerLocation.pathname}${routerLocation.search}`;

  useEffect(() => {
    Aos.init({
      duration: 2000,
      offset: 0,
    });
  }, []);

  const excludedPaths = ["/login", "/register", "/forgot-pin"];
  const isPathExcluded = excludedPaths.includes(routerLocation.pathname);

  const showBackground =
    routerLocation.pathname === "/games" ||
    routerLocation.pathname === "/booming" ||
    routerLocation.pathname === "/slot" ||
    routerLocation.pathname.toLowerCase() === "/aviator" ||
    routerLocation.pathname.toLowerCase() === "/spribe";

  return (
    <>
      <div className={` ${showSideBar ? "BLM-sideMenu-opened" : ""} `}>
        <div
          className="SB-Lite-Mobile mb-[46px] lg:mb-0 max-w-[1440px] mx-auto w-full"
          style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
        >
          {hideGlobalHeaderMobile ? (
            <div className="hidden md:block">
              <Header />
            </div>
          ) : (
            <Header />
          )}
          <div className="flex-1 flex flex-col">
          <Layout>
            <div
              className={`relative BLM-layout-content ${
                !showBackground ? "lg:mt-0" : ""
              } lg:px-6`}
              style={{
                backgroundImage: showBackground
                  ? `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('/assets/images/PNG/games-bg.png')`
                  : "none",
                backgroundAttachment: "scroll",
                backgroundSize: "contain",
                backgroundPosition: "top center",
                backgroundRepeat: "repeat-y",
              }}
            >
              {/* Design-kit layout: sidebar(248px) | content(1fr) | betslip(336px).
                  On desktop we use a 3-column flex instead of the old 12-col grid
                  so the rail and betslip hit their exact token widths. Mobile is
                  unchanged (flex-col, no sidebar/betslip). */}

              <div className={!isPathExcluded ? "lg:flex lg:items-start lg:gap-2" : ""}>
                {showSportsRail && (
                  <div className="hidden lg:block lg:shrink-0" style={{ width: "var(--sidebar-w)" }}>
                    <SportRail
                      groups={sportRailGroups}
                      value={activeSportRailId}
                      onChange={(id) => history.push(id)}
                    />
                  </div>
                )}
                <div
                  className={`min-w-0 flex-1 ${(routerLocation.pathname.includes("/wallet") || routerLocation.pathname === "/payment") ? "!max-w-full" : ""}`}
                >
                  {/* Hero slot: inline in the center column so all three columns
                      (SportRail, content, BetSlip) start at the same vertical level.
                      Header.jsx portals MemoizedPopularSports + Banner into this div. */}
                  {routerLocation.pathname === "/sports" && (
                    <div id="sports-hero-slot" />
                  )}
                  <div
                    className="flex-1 min-w-0"
                    id="pagesChilderen"
                  >
                    {props.children}
                  </div>
                </div>
                {!isPathExcluded && (
                  <div
                    className={`hidden lg:shrink-0 md:pt-10 ${
                      showBetSlip ? "lg:block" : "lg:hidden"
                    }`}
                    style={{ width: "var(--betslip-w)" }}
                  >
                    <div className="flex flex-col gap-4">
                      <BetSlipWidget />
                      {/* Design-kit app shell (ui_kits/sportsbook-web/index.html)
                          only ever shows Play Live Games when page==="sports"
                          (the literal home page) — not on /sports-details,
                          /league-details, etc. CasinosLeft isn't part of the
                          design's right column at all on any page (and its
                          own content is hardcoded mock data — "Claimed
                          Alice!", fake emails/amounts — the real render path
                          for it is already commented out), so it's removed
                          here entirely rather than just retoned. */}
                      {routerLocation.pathname === "/sports" && <Bigwins isLiveGame={true} />}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* </div> */}
          </Layout>
          </div>
          <div className="lg:hidden">{<LeftMenu />}</div>
          {/* Site footer (address/payment methods/social/copyright) is desktop-only;
              mobile web keeps just the bottom tab bar (Footer, rendered below) */}
          <div className="hidden md:block">
            <ContentFooter />
          </div>

          {/* RN floating SlipBar on fixture-browsing screens */}
          {["/sports", "/sports-details", "/league-details", "/AllSports", "/sport", "/fixture-details/show"].includes(
            pathname,
          ) && <SlipBar />}

          {/* RN hides the global tab bar on Refer-a-Friend (it has its own bottom nav) */}
          {pathname !== "/refer-a-friend" && <Footer setOpenBet={setOpenBet} />}
          {openBet && (
            <div
              className="w-full fixed bottom-[50px] !height-[calc(100vh - 50px)]"
              id="default-modal"
              tabindex="-1"
            >
              <BetSlip setOpenBet={setOpenBet} />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default AppLayout;
